import "./AboutHero.css";
import { Link } from "react-router-dom";
export default function AboutHero() {
  return (
    <section className="about-hero">
      <div className="ah-overlay"></div>

      <div className="ah-content">
        <h1 className="ah-title">About Us</h1>
        <p className="ah-subtitle">
          A taste of perfection in every dish – <span>fine dining</span>
        </p>

        <div className="ah-breadcrumb">
          <Link to="/">Home</Link>
          <span className="ah-arrow">›</span>
          <span>About Us</span>
        </div>

        <div className="ah-scroll">
          <div className="scroll-icon"></div>
        </div>
      </div>
    </section>
  );
}
